import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import clientService from '../../services/ClientService';
import { useDispatch } from 'react-redux';



export const initialState = {
	loading: false,
	message: '',
	list:null,
	
}




export const processListAll = createAsyncThunk('process/list',async (data, { rejectWithValue }) => {
	
	
    try {
		const response = await clientService.getProcess(data)
		return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})



export const processSlice = createSlice({
	name: 'process',
	initialState,
	reducers: {
			
		processList: (state, action) => {
			state.loading = true
			state.list = action.payload
		},
		
	},
	extraReducers: (builder) => {
		builder
		.addCase(processListAll.pending, (state) => {
		
				state.loading = false
			})
			.addCase(processListAll.fulfilled, (state, action) => {
				state.loading = true
				state.list = action.payload
			})
			
			
	},
})

export const { 
	processList
    
    
} = processSlice.actions

export default processSlice.reducer